import React, { useState, useRef, useEffect } from 'react';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import blackmarker from '../../images/blackmarker.svg';
import greenmarker from '../../images/greenmarker.svg';
import { translate } from '../Services/translation';

export function GoogleMapContainer(props) {
  const { google, markers } = props;
  const [filteredMarkers, setFilteredMarkers] = useState(markers);
  const [centeredMarker, setCenteredMarker] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const markerRefs = useRef([]);
  const [query, setQuery] = useState('');

  const blueMap = window.mapSettings.blueMap;
  const greyMap = window.mapSettings.greyMap;
  const showSearch = window.mapSettings.showSearch;
  let map_marker = showSearch ? blackmarker : greenmarker;
  let mapStyle = showSearch ? greyMap : blueMap;

  const onMarkerClick = (props, marker, e) => {
    setSelectedMarker(marker);
    setCenteredMarker(marker.position);
  };
  const markerSelected = (event, marker) => {
    setCenteredMarker({
      lat: parseFloat(marker.MapLat),
      lng: parseFloat(marker.MapLong),
    });

    let clickedMarkerRef = markerRefs.current.filter(
      (x) => x.props.name == marker.StoreName
    );
    if (clickedMarkerRef && clickedMarkerRef.length > 0) {
      onMarkerClick(clickedMarkerRef[0].props, clickedMarkerRef[0].marker);
    }
  };
  const filterMarkers = (value) => {
    setQuery(value);
    if (value !== '') {
      value = value.toLowerCase();
      const result = markers.filter(
        (marker) =>
          marker.StoreName.toString().toLowerCase().includes(value) ||
          marker.StoreStreet.toString().toLowerCase().includes(value) ||
          marker.StoreZipCode.toString().toLowerCase().includes(value)
      );
      setFilteredMarkers(result);
    } else {
      setFilteredMarkers(markers);
    }
  };

  const mapLoaded = (mapProps, map) => {
    map.setOptions({
      styles: mapStyle,
      maxZoom: 18,
      minZoom: 4,
    });
  };

  const containerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
  };

  const initMap = (props, map) => {
    const bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < filteredMarkers.length; i++) {
      if (filterMarkers[i].MapLat == null || filterMarkers[i].MapLong == null) {
        continue;
      }
      var x = {
        lat: parseFloat(filteredMarkers[i].MapLat),
        lng: parseFloat(filteredMarkers[i].MapLong),
      };
      bounds.extend(x);
    }
    mapLoaded(props, map);
    map.fitBounds(bounds);
    map.panToBounds(bounds);
  };

  const openStore = (markerSelected) => {
    location.href = markerSelected.Url;
  };

  let columnsSize = showSearch
    ? 'columns small-12 medium-6 large-6 google-map__map'
    : 'columns google-map__map';

  return (
    <>
      <div className="row google-map__wrapper">
        {showSearch && (
          <div className="columns small-12 medium-6 large-6 google-map__list">
            <div className="google-map__search">
              <input
                autoComplete="do-not-autocomplete"
                placeholder={translate('google.maps.placeholder')}
                value={query}
                onChange={(e) => filterMarkers(e.target.value)}
              />
              <div className="google-map__search-btn">
                <i className="ph-magnifying-glass"></i>
              </div>
            </div>
            <ul>
              {filteredMarkers.map((marker, i) => (
                <div
                  className="google-map__list-item"
                  key={marker.StoreName + '-' + i}
                >
                  <li>
                    <div className="li-text">
                      <h4>{marker.StoreName}</h4>
                      <div
                        className="storestreet"
                        dangerouslySetInnerHTML={{ __html: marker.StoreStreet }}
                      ></div>
                      <div
                        className="storezipcode"
                        dangerouslySetInnerHTML={{
                          __html: marker.StoreZipCode,
                        }}
                      ></div>
                    </div>
                    <div className="storelocator-links">
                      <div className="storebutton">
                        <input
                          type="button"
                          onClick={(e) => openStore(marker)}
                          value={translate('google.maps.storedetails')}
                        ></input>
                      </div>
                      <div className="storelink">
                        <a onClick={(e) => markerSelected(e, marker)}>
                          {translate('google.maps.findstore')}
                        </a>
                      </div>
                    </div>
                  </li>
                </div>
              ))}
            </ul>
          </div>
        )}
        <div className={columnsSize}>
          <Map
            google={google}
            zoom={5}
            containerStyle={containerStyle}
            initialCenter={{
              lat: 58.977157,
              lng: 14.038979,
            }}
            fullscreenControl={false}
            streetViewControl={false}
            zoomControl={false}
            mapTypeControl={false}
            center={centeredMarker}
            onReady={(mapProps, map) => initMap(mapProps, map)}
          >
            {filteredMarkers.map((marker, i) => (
              <Marker
                key={marker.StoreName}
                ref={(marker) => (markerRefs.current[i] = marker)}
                name={marker.StoreName}
                title={marker.StoreName}
                linkaddress={marker.StoreWebb}
                street={marker.StoreStreet}
                zipcode={marker.StoreZipCode}
                position={{
                  lat: parseFloat(marker.MapLat),
                  lng: parseFloat(marker.MapLong),
                }}
                onClick={onMarkerClick}
                icon={{
                  url: map_marker,
                  anchor: new google.maps.Point(12, 24),
                  scaledSize: new google.maps.Size(30, 30),
                }}
              />
            ))}
            <InfoWindow marker={selectedMarker} visible={selectedMarker}>
              <>
                {selectedMarker && (
                  <div>
                    <h6>{selectedMarker.name}</h6>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: selectedMarker.street,
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: selectedMarker.zipcode,
                      }}
                    ></p>
                  </div>
                )}
              </>
            </InfoWindow>
          </Map>
        </div>
      </div>

      {!showSearch && (
        <div className="row store__container">
          <div className="columns small-12">
            <div className="stores">
              <h3>{translate('google.maps.premiumstores')}</h3>
              <ul className="store__list">
                {filteredMarkers.map((store) => (
                  <>
                    {store.StorePremium && (
                      <li key={'store__' + store.StoreName}>
                        <div className="storeitem">
                          <h6>{store.StoreName}</h6>
                          <div>
                            <p>{store.StoreStreet}</p>
                          </div>
                          <div>
                            <p>{store.StoreZipCode}</p>
                          </div>
                          <div>
                            <p>
                              <a href={'tel:' + store.StorePhoneNumber}>
                                {store.StorePhoneNumber}
                              </a>
                            </p>
                          </div>
                          <div>
                            <p>
                              <a
                                href={store.StoreWebb}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {store.StoreWebb}
                              </a>
                            </p>
                          </div>
                          <a href="#">
                            <div
                              className="selectedmarker"
                              title="Show me"
                              onClick={(e) => markerSelected(e, store)}
                            >
                              <p>{translate('google.maps.findonmap')}</p>
                            </div>
                          </a>
                        </div>
                      </li>
                    )}
                  </>
                ))}
              </ul>
            </div>
            <div className="stores">
              <h3>{translate('google.maps.estores')}</h3>
              <ul className="store__list">
                {filteredMarkers.map((store) => (
                  <>
                    {store.EStore && (
                      <li key={'store__' + store.StoreName}>
                        <div className="storeitem">
                          <h6>{store.StoreName}</h6>
                          <div>
                            <p>
                              <a
                                href={store.StoreWebb}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {store.StoreWebb}
                              </a>
                            </p>
                          </div>
                        </div>
                      </li>
                    )}
                  </>
                ))}
              </ul>
            </div>
            <div className="stores">
              <h3>{translate('google.maps.baspartner')}</h3>
              <ul className="store__list">
                {filteredMarkers.map((store) => (
                  <>
                    {!store.StorePremium && !store.EStore && (
                      <li key={'store__' + store.StoreName}>
                        <div className="storeitem">
                          <h6>{store.StoreName}</h6>
                          <div>
                            <p>{store.StoreStreet}</p>
                          </div>
                          <div>
                            <p>{store.StoreZipCode}</p>
                          </div>
                          <div>
                            <p>
                              <a href={'tel:' + store.StorePhoneNumber}>
                                {store.StorePhoneNumber}
                              </a>
                            </p>
                          </div>
                          <div>
                            <p>
                              <a
                                href={store.StoreWebb}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {store.StoreWebb}
                              </a>
                            </p>
                          </div>
                          <a href="#">
                            <div
                              className="selectedmarker"
                              title="marker"
                              onClick={(e) => markerSelected(e, store)}
                            >
                              <p>{translate('google.maps.findonmap')}</p>
                            </div>
                          </a>
                        </div>
                      </li>
                    )}
                  </>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default GoogleApiWrapper((props) => ({
  language: props.language,
  apiKey: props.apiKey,
}))(GoogleMapContainer);
